import { ReactNode } from "react";

import RowLayout from "./row-layout";
import ColumnLayout from "./column-layout";

function FlexiLayout({
  aboutContentPosition = "left",
  mainContent,
  aboutContent,
  actions,
  splitActions
}: {
  aboutContentPosition?: "left" | "top"; // Determines where to place the sidebar
  mainContent: ReactNode; // Main content of the layout
  aboutContent: ReactNode; // Content for the sidebar
  actions?: { component: ReactNode; position: "left" | "right" }[]; // Actions to display in the sticky action bar
  splitActions?: boolean;
}) {
  if (aboutContentPosition === "top") {
    return (
      <RowLayout
        aboutContent={aboutContent}
        mainContent={mainContent}
        actions={actions}
        splitActions={splitActions}
      />
    );
  }

  return (
    <ColumnLayout
      aboutContent={aboutContent}
      mainContent={mainContent}
      actions={actions}
      splitActions={splitActions}
    />
  );
}

export default FlexiLayout;
